import React, { useState, useEffect } from 'react'
import { SubmitHandler, useForm, UseFormReturn } from 'react-hook-form'
import { BodyParams, ErrorBoxComponent, FieldProps, FormDataBase, FormWrapper, onSubmit } from '../common/FormBase'
import { companyIDField, datePickerField, idField, imeiField, machineFailureTypeField, machineTypeIDField, requiredTextField, speechField, textareaField } from '../common/fields'
import { MachineFailureTypes } from '@/services/repository/machines'
import { galleryField } from '../common/fields/gallery'
import { CurrentSession } from '@/services/repository/session'

export interface MachineFailureFormData extends FormDataBase {
  id?: string
  description: string
  machineFailureTypeId: MachineFailureTypes
  machineId: string
  servicemanId: string
  reportingUserId: string
  detectionDate: Date
  commencementDate: Date
}

export interface MachineFailureFormParams extends BodyParams<MachineFailureFormData> {
  session?: CurrentSession
  onSubmit: onSubmit<MachineFailureFormData>
}

export const SuperAdminMachineFailureBody = (params: BodyParams<MachineFailureFormData> & {
  session: CurrentSession
}) => {
  const fieldProps: FieldProps<MachineFailureFormData> = {
    ...params,
    fieldName: ''
  }
  return <>
    {id(fieldProps)}
    {description(fieldProps)}
    {type(fieldProps)}
    {machineId(fieldProps)}
    {servicemanId(fieldProps)}
    {reportingUserId(fieldProps)}
    {detectionDate(fieldProps)}
    {detectionDate(fieldProps)}
    {commencementDate(fieldProps)}
  </>
}

export const NewMachineFailureBody = (params: BodyParams<MachineFailureFormData> & {
  session?: CurrentSession
}) => {
  const fieldProps: FieldProps<MachineFailureFormData> = {
    ...params,
    fieldName: ''
  }
  return <>
    {description(fieldProps)}
    {gallery(fieldProps)}
    {type(fieldProps)}
  </>
}

// export const SuperAdminEditMachineFailureForm = (params: MachineFailureFormParams) => {
//   const formHandler: SubmitHandler<MachineFailureFormData> = (data) => {
//     params.onSubmit(data)
//   }
//   return <FormWrapper<MachineFailureFormData> className='main-form' {...params} formName='machine_failures' onSubmit={formHandler}>
//     <SuperAdminMachineFailureBody {...params} />
//   </FormWrapper>
// }

export const NewMachineFailureForm = (params: MachineFailureFormParams) => {
  const formHandler: SubmitHandler<MachineFailureFormData> = (data) => {
    params.onSubmit(data);
  }
  return <FormWrapper<MachineFailureFormData> className='main-form' {...params} formName='machine_failures' onSubmit={formHandler}>
    <NewMachineFailureBody {...params} />
  </FormWrapper>
}

export const id = (props: FieldProps<MachineFailureFormData>) => idField<MachineFailureFormData>()({ ...props, fieldName: props.fieldName || 'id', formName: props.formName || 'machine_failures' })
export const gallery = (props: FieldProps<MachineFailureFormData>) => galleryField<MachineFailureFormData>()({ ...props, fieldName: props.fieldName || 'galleryId', formName: props.formName || 'machine_failures' })
export const description = (props: FieldProps<MachineFailureFormData>) => speechField<MachineFailureFormData>()({ ...props, fieldName: props.fieldName || 'description', formName: props.formName || 'machine_failures' })
export const type = (props: FieldProps<MachineFailureFormData>) => machineFailureTypeField<MachineFailureFormData>()({ ...props, fieldName: props.fieldName || 'machineFailureTypeId', formName: props.formName || 'machine_failures' })
export const machineId = (props: FieldProps<MachineFailureFormData>) => requiredTextField<MachineFailureFormData>()({ ...props, fieldName: props.fieldName || 'machineId', readOnly: true, formName: props.formName || 'machine_failures' })
export const servicemanId = (props: FieldProps<MachineFailureFormData>) => requiredTextField<MachineFailureFormData>()({ ...props, fieldName: props.fieldName || 'servicemanId', readOnly: true, formName: props.formName || 'machine_failures' })
export const reportingUserId = (props: FieldProps<MachineFailureFormData>) => requiredTextField<MachineFailureFormData>()({ ...props, fieldName: props.fieldName || 'reportingUserId', readOnly: true, formName: props.formName || 'machine_failures' })
export const detectionDate = (props: FieldProps<MachineFailureFormData>) => datePickerField<MachineFailureFormData>()({ ...props, fieldName: props.fieldName || 'detectionDate', formName: props.formName || 'machine_failures' })
export const commencementDate = (props: FieldProps<MachineFailureFormData>) => datePickerField<MachineFailureFormData>()({ ...props, fieldName: props.fieldName || 'commencementDate', formName: props.formName || 'machine_failures' })
